/* eslint-disable no-unused-vars */

/* eslint-disable react/prop-types */

/* eslint-disable react/display-name */
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';

import { theme } from '_constants/theme';

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
`;

const StyledImg = styled.img`
  border-radius: 12px;

  ${({ size }) =>
    size &&
    css`
      height: ${size}px;
      width: ${size}px;
    `}
`;

const StyledPlaceholder = styled(
  forwardRef(({ size, bgColor, textColor, ...props }, ref) => <div ref={ref} {...props} />)
)`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;

  font-size: ${theme.fontSizes.regular}px;
  font-weight: 700;

  ${({ size }) =>
    size &&
    css`
      height: ${size}px;
      width: ${size}px;
    `}

  ${({ bgColor }) =>
    bgColor &&
    css`
      background: ${bgColor};
    `}

  ${({ textColor }) =>
    textColor &&
    css`
      color: ${textColor};
    `}
`;

const Avatar = ({ url, name, bgColor, textColor, size, ...restProps }) => {
  return (
    <StyledContainer {...restProps}>
      {url ? (
        <StyledImg src={url} alt={name} size={size} />
      ) : (
        <StyledPlaceholder bgColor={bgColor} textColor={textColor} size={size}>
          {name?.slice(0, 1)?.toUpperCase()}
        </StyledPlaceholder>
      )}
    </StyledContainer>
  );
};

Avatar.propTypes = {
  url: PropTypes.string,
  name: PropTypes.string,
  role: PropTypes.string,
  bgColor: PropTypes.string,
  textColor: PropTypes.string,
  size: PropTypes.number,
};

Avatar.defaultProps = {
  url: '',
  name: 'User',
  bgColor: theme.colors.cyanBlue,
  textColor: theme.colors.white,
  size: 40,
};

export default Avatar;
